var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-outline-info px-3 border-0 ml-2",attrs:{"id":"menu-toggle"},on:{"click":_vm.toggleSideNavHidden}},[_c('i',{staticClass:"fas fa-bars pt-1",staticStyle:{"font-size":"24px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }